// extracted by mini-css-extract-plugin
module.exports = {"section":"DPUX_section__UqXXo"};